import mapLabels from './map_labels';
import mapMarkers from './map_markers'

export const getMapLabels = (componentToRender, pageWidth) => {
    if (!pageWidth || !mapLabels[componentToRender]) return null;

    // Map breakpoints refer to gridle states mapSm
    if (pageWidth >= 769 && pageWidth <= 1110) {
        return mapLabels[componentToRender].small;
    }

    // Map breakpoints refer to gridle states mapMd
    if (pageWidth > 1110 && pageWidth <= 1440) {
        return mapLabels[componentToRender].medium;
    }

    return mapLabels[componentToRender].default;
};

export const getMapMarkers = (componentToRender, pageWidth) => {
    if (!pageWidth || !mapMarkers[componentToRender]) return null;

    // Map breakpoints refer to gridle states mapSm
    if (pageWidth >= 769 && pageWidth <= 1110) {
        return mapMarkers[componentToRender].small;
    }

    // Map breakpoints refer to gridle states mapMd
    if (pageWidth > 1110 && pageWidth <= 1440) {
        return mapMarkers[componentToRender].medium;
    }

    return mapMarkers[componentToRender].default;
};



// WEBPACK FOOTER //
// ./web/js/components/user_demographic_map/map_helper.js